import Vue from 'vue'
import VueRouter from 'vue-router'
import test from '../views/test.vue'
import main from '../views/main.vue'
import realdata from '../views/realdata/realdata.vue'
import auditoperation from '../views/auditoperation/auditoperation.vue'
import registration from '../views/registration/registration.vue'
import authority from '../views/authority/authority.vue'

// import setting from '../views/setting/setting.vue'
import setting from '../views/setting/settingNew.vue'
import login from '../views/Login.vue'
import QueryEnroll from "@/views/QueryEnroll.vue";


Vue.use(VueRouter)

const routes = [
    {
        path: '/queryEnroll',
        name: 'queryEnroll',
        component: QueryEnroll
    },
    {
        path: '/test',
        name: 'test',
        component: test
    }, {
        path: '/',
        name: 'login',
        component: login
    }, {
        path: '/main',
        name: 'main',
        component: main,
        children: [
            {path: "realdata", component: realdata},
            {path: "auditoperation", component: auditoperation},
            {path: "registration", component: registration},
            {path: "authority", component: authority},
            {path: "setting", component: setting},

        ]
    }]

const router = new VueRouter({
    routes
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    if (to.path === '/' || to.path === '/test' || to.path === '/queryEnroll') {
        next();
    } else {
        // let token = sessionStorage.getItem('token');
        let baseInfo = sessionStorage.getItem("operatorID");
        // console.log("导航守卫", baseInfo);

        // if (token === 'null' || token === '') {
        if (baseInfo === 'null' || baseInfo === '' || baseInfo == null) {
            next('/');
        } else {
            next();
        }
    }
});
//重复路由
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
